import React from 'react';
import { FileText } from 'lucide-react';
import { toast } from 'sonner';
import { hcApi, hcError } from './api';

const openDoc = async (r, d) => {
  const win = window.open('', '_blank');
  try {
    const res = await hcApi.get(`/supportive-service-requests/${r.id}/documents/${d.kind}`, { responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    if (win) win.location.href = url; else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (err) {
    if (win) win.close();
    toast.error(hcError(err, "We couldn't open this file. Please try again."));
  }
};

const RequestExtras = ({ r }) => {
  const bills = (r.documents || []).filter((d) => d.kind === 'internet_bill');
  if (!r.internet_amount && !bills.length) return null;
  return (
    <div className="mt-1 space-y-1">
      {r.internet_amount && <p className="text-sm text-gray-600" data-testid={`hc-ssr-request-amount-${r.number}`}>Amount requested: <span className="font-semibold text-[#363636]">{r.internet_amount}</span></p>}
      {bills.map((d) => (
        <button key={d.kind} type="button" onClick={() => openDoc(r, d)} className="inline-flex items-center gap-1 text-sm text-[#922A8C] font-semibold hover:underline max-w-full"
          data-testid={`hc-ssr-request-doc-${d.kind}-${r.number}`}>
          <FileText className="w-4 h-4 shrink-0" /><span className="truncate">{d.filename || d.label}</span>
        </button>
      ))}
    </div>
  );
};

export const HcSsrMyRequests = ({ requests }) => (
  <section className="mt-8" data-testid="hc-ssr-my-requests">
    <h2 className="text-base md:text-lg font-bold text-[#363636] mb-3">My Requests</h2>
    {requests.length === 0 ? (
      <p className="text-gray-500 text-sm" data-testid="hc-ssr-no-requests">You haven't submitted any requests yet.</p>
    ) : (
      <div className="bg-white rounded-2xl border border-gray-100 divide-y divide-gray-100">
        {requests.map((r) => (
          <div key={r.id} className="p-4 flex items-center justify-between gap-3" data-testid={`hc-ssr-request-${r.number}`}>
            <div className="min-w-0">
              <p className="font-semibold text-[#363636]" data-testid={`hc-ssr-request-type-${r.number}`}>{r.support_type}</p>
              <p className="text-xs text-gray-500" data-testid={`hc-ssr-request-date-${r.number}`}>{r.request_date}</p>
              <RequestExtras r={r} />
            </div>
            <span className={`shrink-0 text-xs font-semibold px-3 py-1 rounded-full ${r.status === 'closed' ? 'bg-gray-100 text-gray-600' : 'bg-amber-50 text-amber-700'}`}
              data-testid={`hc-ssr-request-status-${r.number}`}>{r.status === 'closed' ? 'Closed' : 'Open'}</span>
          </div>
        ))}
      </div>
    )}
  </section>
);
